/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bandage_medium'
export default icon
